<template>
    <v-layout column class="community_banner">
      <v-layout row wrap>
        <v-flex xs12 sm8>
          <Breadcrumb />
        </v-flex>
      </v-layout>
    </v-layout>
</template>
  
  

<script>
    import Breadcrumb from "../Layout/Breadcrumb";

    export default {
        name: 'CommunityBanner',
        components: {
            Breadcrumb,
        },
        data: () => ({}),
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .community_banner {
        background: url(../../assets/ypo-banner.jpg);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 64px;

        @include breakpoint(xs) {
            margin-top: 125px !important;
        }

        &:before {
            content: '';
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .awards_block {
            position: absolute;
            right: 29px;
            top: 20px;
            z-index: 1;
            text-align: right;
            font-size: 12px;
            color: $white;
            font-family: 'Raleway', sans-serif;

            span {
                float: left;
                padding-top: 12px;
                font-size: 10px;
            }

            strong {
                display: block;
                font-size: 14px;
                font-weight: 500;
            }

            img {
                max-width: 28px;
                float: right;
                margin-left: 3px;
            }
        }


    }
</style>
